export default __webpack_public_path__ + "static/media/tablePlant_S.fbf75b14.png";